import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { VerificationComponent } from './verification.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: 'verify_otp', component: VerificationComponent
      }
    ])
  ],
  declarations: [],
  exports: [RouterModule]
})
export class VerificationRoutingModule { }
